import React from 'react'
import styled from 'styled-components'
import {Button} from 'grommet/components/Button'
import {_L, useLocaleState} from '../../../../context/LocaleContext'

const Container = styled.div`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: 'title department button' 'area department button';
  grid-column-gap: 20px;
  grid-row-gap: 8px;
  height: 100%;
  width: 100%;
  justify-items: left;
  background-color: #ffffff;
  border-bottom: 1px solid #f3f5fb;
  box-sizing: border-box;
  cursor: pointer;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 0 200px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr 0 130px;
  }
`

const Title = styled.div`
  padding: 24px 24px 0 24px;
  grid-area: title;
  justify-self: start;
`

const Department = styled.div`
  margin: 24px 0 24px 0;
  border-radius: 6px;
  grid-area: department;
  padding: 12px 70px 12px 70px;
  background-color: ${props => props.backgroundColor};

  @media (max-width: 1024px) {
    display: none;
  }

  @media (max-width: 768px) {
    padding: 12px 24px 12px 24px;
    display: flex;
  }

  @media (max-width: 420px) {
    display: none;
  }
`

const DepartmentName = styled.div`
  text-align: center;
  font-weight: normal;
  color: ${props => props.color};
`

const Area = styled.div`
  grid-area: area;
  padding: 0 24px 17px 24px;
  justify-self: start;
  color: #a4a9b7;
  font-weight: normal;
  line-height: 0.4em;
`

const BookButton = styled(Button)`
  margin: 24px 8px 24px 0;
  padding: 12px 0 12px 0;
  width: 157px;
  color: white;
  background-color: #3395fe;
  border-radius: 6px;
  border-color: #3395fe;
  text-align: center;

  @media (max-width: 768px) {
    width: 130px;
  }

  @media (max-width: 420px) {
    width: 100px;
  }
`

const ButtonContainer = styled.div`
  grid-area: button;
  justify-self: end;
  box-sizing: border-box;
  margin-right: 16px;
`
const WorkspaceItem = ({user, item, onBook}) => {
  const localeState = useLocaleState()
  const {rmTypeDesc, rmId, category, area} = item
  const roomArea = parseFloat(area).toFixed(2)

  const areaUnits = user.areaUnits.title

  const onClick = () => onBook(item)

  return (
    <Container>
      <Title>
        {rmId} - {category}
      </Title>
      <Area>
        {roomArea} {areaUnits}
      </Area>
      <Department backgroundColor={'#E8F3FF'}>
        <DepartmentName color={'#3395fe'}>{rmTypeDesc}</DepartmentName>
      </Department>
      <ButtonContainer>
        <BookButton onClick={onClick}>
          {_L({key: 'Book', localeState})}
        </BookButton>
      </ButtonContainer>
    </Container>
  )
}

export default WorkspaceItem
